import { useState } from "react";
import {
  deleteTheme,
  getAllThemes,
  getThemesById,
  newTheme,
  updateTheme,
} from "../services/themes.service";

const INITIAL_SUCCESS_ERROR = {
  getAllThemes: "",
  getThemesById: "",
  create: "",
  update: "",
  deleteTheme: "",
};

export const useThemes = ({ spinner }) => {
  const [themesList, setThemesList] = useState([]);
  const [theme, setTheme] = useState({});
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);

  const getThemes = async (params) => {
    clearAlerts();
    const response = await getAllThemes(params);
    if (response.error) {
      setThemesList([]);
      setError({ getAllChairPerson: response.error });
    } else {
      setThemesList(response.data);
    }
  };

  const getTheme = async (id) => {
    clearAlerts();
    const response = await getThemesById(id);
    if (response.error) {
      setTheme({});
      setError({ getThemesById: response.error });
    } else {
      setTheme(response.data);
    }
  };

  const setDeleteTheme = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await deleteTheme(params);
    spinner(false);
    if (response.error) {
      setThemesList([]);
      setError({ deleteTheme: response.error });
    } else {
      setSuccess({ delete: "delete" });
      setThemesList(response.data);
    }
  };

  const create = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await newTheme(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
  };

  const update = async (id, request) => {
    clearAlerts();
    spinner(true);
    const response = await updateTheme(id, request);
    spinner(false);
    if (response.error) {
      setError({ update: response.error });
    } else {
      setSuccess({ update: "update" });
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };

  const sanitizeForTable = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.Themes,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  return {
    getThemes,
    sanitizeForTable,
    setDeleteTheme,
    setThemesList,
    getTheme,
    create,
    update,
    themesList,
    theme,
    success,
    error,
  };
};
